import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import SEOHead from "../seo/SEOHead";
import "./PaymentSuccessPage.css";


function PaymentSuccessPage() {
  const navigate = useNavigate();
  const location = useLocation();

  const isCod = location.state?.isCod === true || location.state?.paymentMethod === "COD";
  const orderNumber = location.state?.orderNumber;
  const amount = location.state?.amount;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <SEOHead
        title={isCod ? "Order Placed Successfully | RealFlame" : "Order Confirmed | RealFlame"}
        description="Your RealFlame order has been placed successfully. Thank you for shopping with us."
        noIndex={true}
      />
    <div className="ps-wrapper">
      <div className="ps-card">

        {/* Animated checkmark */}
        <div className="ps-icon-circle">
          <svg
            className="ps-checkmark"
            viewBox="0 0 52 52"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              className="ps-checkmark-circle"
              cx="26"
              cy="26"
              r="25"
              fill="none"
            />
            <path
              className="ps-checkmark-tick"
              fill="none"
              d="M14 27 l7 7 l17 -17"
            />
          </svg>
        </div>

        <h1 className="ps-title">
          {isCod ? "Order Placed Successfully!" : "Payment Successful!"}
        </h1>

        <p className="ps-subtitle">
          {isCod ? (
            <>Cash on Delivery (COD) order confirmed {orderNumber ? <strong>[{orderNumber}]</strong> : ""}</>
          ) : (
            <>Thank you for shopping with <strong>RealFlame</strong>.</>
          )}
        </p>

        {isCod ? (
          <div style={{
            background: "#fffbeb",
            border: "1px solid #fde68a",
            borderRadius: "8px",
            padding: "16px",
            margin: "20px auto",
            textAlign: "center"
          }}>
            <div style={{ fontWeight: "700", color: "#92400e", marginBottom: "6px" }}>
              💵 Cash on Delivery Summary
            </div>
            {orderNumber && (
              <div style={{ fontSize: "0.95rem", color: "#451a03", marginBottom: "4px" }}>
                <strong>Order ID:</strong> {orderNumber}
              </div>
            )}
            {amount > 0 && (
              <div style={{ fontSize: "1rem", color: "#b45309", fontWeight: "700", marginBottom: "6px" }}>
                Amount to Pay at Delivery: ₹{Number(amount).toLocaleString("en-IN")}
              </div>
            )}
            <div style={{ fontSize: "0.85rem", color: "#78350f" }}>
              Please keep the cash amount ready at the time of delivery. You will receive order updates via email.
            </div>
          </div>
        ) : (
          <p className="ps-body">
            Your order {orderNumber ? `[${orderNumber}] ` : ""}has been confirmed and a payment confirmation along with
            your&nbsp;invoice has been sent to your registered email address.
          </p>
        )}

        <div className="ps-divider" />

        <p className="ps-note">
          You will receive a delivery update once your order is dispatched.
          For any queries, contact us at&nbsp;
          <a href="mailto:info@realflame.in" className="ps-link">
            info@realflame.in
          </a>
        </p>

        <div className="ps-actions">
          <button
            className="ps-btn-primary"
            onClick={() => navigate("/products")}
          >
            Continue Shopping
          </button>
          <button
            className="ps-btn-secondary"
            onClick={() => navigate("/")}
          >
            Go to Home
          </button>
        </div>

      </div>
    </div>
    </>
  );
}

export default PaymentSuccessPage;
